<template>
  <div class="product-container">
    <div class="product-top-panel" v-if="menu_type === undefined">
      <router-link :to="{ name: 'home' }" class="back-link" v-if="category === 'main'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 10L7.14645 9.64645L6.79289 10L7.14645 10.3536L7.5 10ZM12.1464 4.64645L7.14645 9.64645L7.85355 10.3536L12.8536 5.35355L12.1464 4.64645ZM7.14645 10.3536L12.1464 15.3536L12.8536 14.6464L7.85355 9.64645L7.14645 10.3536Z"
            fill="black" />
        </svg>
        <span class="text">{{ $static('item.back', 'Назад в категорію') }}</span>
      </router-link>
      <router-link :to="{ name: 'catalog', params: { category: category } }" v-else class="back-link">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.5 10L7.14645 9.64645L6.79289 10L7.14645 10.3536L7.5 10ZM12.1464 4.64645L7.14645 9.64645L7.85355 10.3536L12.8536 5.35355L12.1464 4.64645ZM7.14645 10.3536L12.1464 15.3536L12.8536 14.6464L7.85355 9.64645L7.14645 10.3536Z"
            fill="black" />
        </svg>
        <span class="text">{{ $static('item.back', 'Назад в категорію') }}</span>
      </router-link>
    </div>

    <div class="product-col-holder">
      <div class="product-images-wrapper">
        <div v-if="item"
          :class="{ 'product-images': item.images.length > 1 || videos?.length, 'product-image': item.images.length <= 1 }">
          <div class="product-label label-new" v-if="isHotItem">
            <span class="label-text">New</span>
          </div>
          <div class="product-label label-sale" v-if="item.price_old && getDiscount(item) > 0">
            <div class="tile_label tile_sale">-{{ getDiscount(item) }}%</div>
          </div>
          <ul class="image_list" ref="itemImageEle" @mousedown="(e) => mouseDownHandler(e, 'itemImageEle')">
            <li v-for="(video, index) in videos" :key="index" class="videoBox">
              <video :src="video.url" aria-hidden="true" playsinline controls muted autoplay loop
                :type="video.type"></video>
            </li>
            <li v-for="(image, index) in item.images" :key="index">
              <a :href="`${getURLImage(image)}`" @click="fancyClick" data-fancybox="zoom" class="image bg-cover"
                :style="{ 'background-image': $filters.getItemImage(image) }"></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="product-wrapper wrapper" v-if="item">
        <div class="product-top-info d-flex align-items-center"
          :class="{ 'product-top-hidden': isCatalogMod || item.advanced?.isService }">
          <div class="availability-holder">
            <div class="availability not-availability" v-if="!isStock">
              <span>{{ $static('item.nema', 'Нема в наявності') }} </span>
            </div>
            <div class="availability in-stock" v-else>
              <span>{{ $static('item.est', 'В наявності') }}</span>
            </div>
          </div>
          <div class="product-id" v-if="item.article">
            <div class="id-name">
              {{ $static('item.art-id', 'Артикул:') }}
              <span class="id-value">{{ item.article }}</span>
            </div>
          </div>
        </div>

        <div class="name h1">{{ $dynamic(item, item.title, 'title') }}</div>

        <div class="related-products groups-relate" v-if="group?.length && categories?.length">
          <ul class="catalog-grid" ref="itemCatalogEle" @mousedown="(e) => mouseDownHandler(e, 'itemCatalogEle')">
            <li class="catalog-item" v-for="(item, index) in group" :key="index">
              <router-link
                :to="{ name: 'ItemOrServiceItem', params: { category: categoryURL(item), id: item.id }, query: $route.query }"
                class="group-relate-link" @click.prevent.stop="">
              </router-link>
              <div class="item-holder">
                <div class="product-label label-new" v-if="isHot(item)">
                  <span class="label-text">New</span>
                </div>
                <div class="product-label label-sale" v-if="item.price_old && getDiscount(item) > 0">
                  <div class="tile_label tile_sale">-{{ getDiscount(item) }}%</div>
                </div>
                <div class="image bg-cover" :style="`background-image: url(${getItemImage(item)});`"></div>
                <div class="product-name">
                  {{ $dynamic(item, item.title, 'title') }}
                </div>
                <div class="options">
                  <div class="price-box">
                    <div class="price-element" v-if="item.price" :class="{ 'was-selled': !!item.price_old }">
                      {{ $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }}
                    </div>
                    <div class="price-old" v-if="item.price_old">
                      {{ $filters.money(item.price_old) }} {{ $store.getters.getSettings.symbol }}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <ItemUniqueOption v-for="(option, index) in uOptions" :key="index" :option_key="index" :option="option"
          @select="selectuOption" />

        <ItemOption v-for="(option, index) in options" :key="index" :option_key="index" :option="option"
          :settings="optionSettings" @select="selectOption" />
        <div class="particular" v-if="ingredient.length > 0">
          <div class="custom-label">
            {{ $static('item.badge-title', 'Особливості') }}
          </div>
          <ul>
            <li v-for="(badge, badgeIndex) in ingredient" :key="badge + badgeIndex">
              <img v-if="badge.image" :src="badge.image" :alt="badge.name" class="label-pic">
              <span v-if="badge.color && !badge.image"
                :style="{ 'backgroundColor': badge.color, 'display': 'inline-block' }" class="label-pic"></span>
              <span class="text">{{ $dynamic(badge, badge.name, 'name') }}</span>
            </li>
          </ul>
        </div>

        <div class="product-buy-options"
          :class="{ 'calc-box': !settings.formula && addPrice, 'paired-box': !settings.formula && !addPrice }">
          <div class="price-box d-flex">
            <div class="price-element" v-if="addPrice" :class="{ 'was-selled': !!item.price_old }">
              <template v-if="!settings.formula">{{ $filters.money(itemPrice) }} + {{
                $filters.money(addPrice) }} =
              </template>
              {{ $filters.money(price) }} {{ $store.getters.getSettings.symbol }}
            </div>
            <div class="price-element" v-else-if="item.price" :class="{ 'was-selled': !!item.price_old }">
              {{ $filters.money(item.price) }} {{ $store.getters.getSettings.symbol }}
            </div>
            <div class="price-old" v-if="item.price_old && item.price">
              {{ $filters.money(price_old) }} {{ $store.getters.getSettings.symbol }}
            </div>
          </div>

          <div class="buttons product-buttons">
            <button class="default-btn" @click="openRequestModal">
              <span class="btn-text">{{ $static('item.leave-request', 'Залишити заявку') }}</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.82307 11.683C4.85955 11.6953 4.89637 11.704 4.93315 11.7094C4.97326 11.8036 5.02509 11.9256 5.08555 12.0682C5.23312 12.4162 5.43194 12.8869 5.63717 13.3779C6.05571 14.3793 6.47789 15.4116 6.57113 15.7071C6.68655 16.0724 6.80856 16.3207 6.94176 16.4902C7.01062 16.5779 7.09028 16.6545 7.18348 16.7124C7.2304 16.7416 7.27996 16.7655 7.33169 16.7834C7.33397 16.7841 7.33625 16.7849 7.33852 16.7857C7.6052 16.8864 7.84833 16.8444 8.00056 16.7931C8.08201 16.7657 8.14791 16.7325 8.19462 16.7057C8.21843 16.692 8.23855 16.6792 8.2546 16.6684L8.25839 16.6659L10.6136 15.1972L13.334 17.2828C13.3742 17.3136 13.418 17.3394 13.4643 17.3597C13.7912 17.5023 14.1076 17.552 14.4054 17.5113C14.7025 17.4708 14.9385 17.3459 15.1142 17.2054C15.2862 17.0677 15.4028 16.9136 15.4754 16.7991C15.5125 16.7406 15.5403 16.6889 15.56 16.6492C15.5698 16.6293 15.5778 16.6122 15.5839 16.5984L15.5918 16.5802L15.5947 16.5731L15.596 16.57L15.5965 16.5686L15.5971 16.5673C15.6113 16.5316 15.6223 16.4946 15.6298 16.4569L18.1133 3.9356C18.1213 3.89556 18.1253 3.85482 18.1253 3.81399C18.1253 3.44732 17.9871 3.09866 17.6622 2.88708C17.3846 2.70625 17.0753 2.69847 16.8798 2.7133C16.6689 2.72931 16.4742 2.78136 16.3435 2.82295C16.2755 2.8446 16.2184 2.86549 16.1773 2.88142C16.1567 2.88943 16.1397 2.89631 16.1271 2.90155L16.1176 2.90554L2.1895 8.36933L2.18769 8.36997C2.17882 8.3732 2.16742 8.37746 2.15388 8.38273C2.12691 8.39323 2.09077 8.40802 2.04856 8.42716C1.96624 8.46446 1.85076 8.52277 1.73225 8.60392C1.54293 8.73357 1.10752 9.08866 1.18084 9.67474C1.23933 10.1423 1.55965 10.4295 1.75481 10.5676C1.86196 10.6434 1.96377 10.6976 2.03791 10.7329C2.07231 10.7493 2.14372 10.7783 2.17471 10.7909L2.18253 10.7941L4.82307 11.683ZM16.6051 4.05654L16.6031 4.05738C16.5962 4.0604 16.5892 4.06329 16.5822 4.06605L2.63712 9.53647C2.62984 9.53933 2.62251 9.54204 2.61512 9.54462L2.60736 9.54756C2.59844 9.55103 2.58342 9.55714 2.56457 9.56568C2.55388 9.57053 2.54272 9.57581 2.53135 9.58149C2.54697 9.59029 2.56193 9.59793 2.57522 9.60426C2.58798 9.61033 2.59771 9.61449 2.60304 9.61667L5.22189 10.4983C5.26983 10.5145 5.31451 10.5359 5.35553 10.5616L14.0029 5.49954L14.011 5.49476C14.0173 5.49105 14.0255 5.48625 14.0355 5.48064C14.0551 5.46952 14.0822 5.45472 14.1143 5.43835C14.1744 5.4078 14.2704 5.36246 14.3785 5.32903C14.4539 5.30575 14.6759 5.24018 14.916 5.31718C15.0642 5.36471 15.2176 5.46687 15.3174 5.63996C15.3669 5.72595 15.3934 5.81233 15.4061 5.89141C15.4401 6.01598 15.4348 6.13899 15.4082 6.24519C15.3509 6.47394 15.1901 6.65238 15.0439 6.78886C14.9186 6.90587 13.2974 8.46908 11.6982 10.0122C10.9006 10.7818 10.1112 11.5437 9.52113 12.1133L9.13359 12.4874L14.0269 16.2389C14.1391 16.2791 14.2055 16.277 14.2362 16.2729C14.2727 16.2679 14.3027 16.2538 14.3332 16.2293C14.3674 16.202 14.3973 16.165 14.4197 16.1298L14.4206 16.1283L16.8293 3.98416C16.7936 3.99275 16.7574 4.00299 16.7226 4.01408C16.6831 4.02664 16.6506 4.03859 16.629 4.04695C16.6184 4.05109 16.6107 4.05424 16.6065 4.05597L16.6051 4.05654ZM9.55398 14.3848L8.57774 13.6363L8.34119 15.1411L9.55398 14.3848ZM7.68217 12.1512L8.65298 11.2139C9.24306 10.6443 10.0326 9.88231 10.8302 9.11269L11.6406 8.33081L6.20723 11.5115L6.23638 11.5802C6.38447 11.9295 6.58418 12.4023 6.7905 12.8959C6.94477 13.265 7.10609 13.6537 7.25303 14.0135L7.48889 12.5132C7.51163 12.3685 7.5823 12.2433 7.68217 12.1512Z"
                  fill="white" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="product-info wrapper" v-if="item">
      <div class="custom-tabs">
        <ul class="nav nav-pills " id="product-tabs" role="tablist">
          <li class="nav-item" v-if="item.description && item.description.length > 7">
            <a class="nav-link active" data-toggle="pill" href="#description_" role="tab" aria-selected="true">
              {{ $static('item.op1', 'Опис') }}
            </a>
          </li>
          <li class="nav-item" v-if="item.advanced && item.advanced.text1 && item.advanced.text1.length > 7">
            <a class="nav-link" :class="{ 'active': !item.description || !item.description.length > 7 }"
              data-toggle="pill" href="#tab_2" role="tab" aria-selected="false">
              {{ $static('item.text1', 'Характеристики') }}
            </a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="description_" role="tabpanel" v-if="item.description">
            <div class="panel-body">
              <div class="text" v-html="shortItemDescription.html">

              </div>
              <div class="info-more-label" v-if="shortItemDescription.isReadMore">
                <a class="show-more-label" @click.prevent="openReadMore('description')">
                  <span class="text">{{ $static('item.more-inf-btn', 'Читати більше') }}</span>
                </a>
              </div>
            </div>
          </div>
          <div class="tab-pane fade"
            :class="{ 'show': !item.description || !item.description.length > 7, 'active': !item.description || !item.description.length > 7 }"
            id="tab_2" role="tabpanel" v-if="item.advanced && item.advanced.text1">
            <div class="panel-body">
              <div class="text" v-html="shortItemCharacteristics.html"></div>
              <div class="info-more-label" v-if="shortItemCharacteristics.isReadMore">
                <a class="show-more-label" @click.prevent="openReadMore('сharacteristics')">
                  <span class="text">{{ $static('item.more-inf-btn', 'Читати більше') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="related-products" v-if="upsaleItems && upsaleItems.length">
      <div class="name h2">{{ $static('item.related', 'З цим часто купують:') }}</div>
      <ul class="catalog-grid" ref="itemCatalog2ele" @mousedown="(e) => mouseDownHandler(e, 'itemCatalog2ele')">
        <li class="catalog-item" v-for="(item, index) in upsaleItems" :key="index">
          <div class="item-holder" v-if="categories?.length">
            <div class="product-label label-new" v-if="isHot(item)">
              <span class="label-text">New</span>
            </div>
            <div class="product-label label-sale" v-if="item.price_old && getDiscount(item) > 0">
              <div class="tile_label tile_sale">-{{ getDiscount(item) }}%</div>
            </div>
            <router-link
              :to="{ name: 'ItemOrServiceItem', params: { category: categoryURL(item), id: item.id }, query: $route.query }"
              class="image bg-cover" @click.prevent.stop=""
              :style="{ 'background-image': $filters.getItemImage(item.preview) }"></router-link>
            <div class="item-content">
              <div class="product-name">
                <router-link
                  :to="{ name: 'ItemOrServiceItem', params: { category: categoryURL(item), id: item.id }, query: $route.query }">
                  {{ $dynamic(item, item.title, 'title') }}
                </router-link>

              </div>
            </div>
            <div class="options">
              <div class="price-box">
                <div class="price-element" :class="{ 'was-selled': !!item.price_old }"> {{ $filters.money(item.price) }}
                  {{ $store.getters.getSettings.symbol }}
                </div>
                <div class="price-old" v-if="item.price_old"> {{ $filters.money(item.price_old) }}
                  {{ $store.getters.getSettings.symbol }}
                </div>
              </div>
              <div class="right-options">
                <router-link
                  :to="{ name: 'ItemOrServiceItem', params: { category: categoryURL(item), id: item.id }, query: $route.query }"
                  class="default-btn btn-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.25 7.08331L6.25 6.66664C6.25 4.59558 7.92893 2.91665 10 2.91664V2.91664C12.0711 2.91664 13.75 4.59557 13.75 6.66664L13.75 7.08331"
                      stroke="white" stroke-linecap="round" />
                    <path d="M12.9167 11.25V9.58331" stroke="white" stroke-linecap="round" />
                    <path d="M7.08333 11.25V9.58331" stroke="white" stroke-linecap="round" />
                    <path
                      d="M4.58333 10.6833C4.58333 8.98626 4.58333 8.13773 5.11054 7.61052C5.63774 7.08331 6.48627 7.08331 8.18333 7.08331H11.8167C13.5137 7.08331 14.3622 7.08331 14.8895 7.61052C15.4167 8.13773 15.4167 8.98626 15.4167 10.6833V11.6666C15.4167 13.9324 15.4167 15.0653 14.836 15.8572C14.655 16.104 14.4374 16.3217 14.1906 16.5026C13.3987 17.0833 12.2658 17.0833 9.99999 17.0833V17.0833C7.73422 17.0833 6.60133 17.0833 5.8094 16.5026C5.5626 16.3217 5.34495 16.104 5.16399 15.8572C4.58333 15.0653 4.58333 13.9324 4.58333 11.6666V10.6833Z"
                      stroke="white" />
                  </svg>
                </router-link>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="frame-modal-wrapper more-info-product" :class="{ 'opened': readMoreOpen }" id="more_info_product">
    <div class="modal-wrapper-holder" v-if="selectedPillType === 'сharacteristics'">
      <div class=" frame-modal-header">
        <div class=" name h2">{{ $static('item.сharact', 'Характеристики товару:') }}</div>
        <a href="javascript:void(0);" @click="closeReadMore" class="close-cart">
          <img src="/images/icons/close.svg" alt="">
        </a>
      </div>
      <div class="frame-modal-body" v-if="item">
        <div class="info-text" v-html="$dynamic(item, item?.advanced?.text1, 'сharacteristics')">
        </div>
      </div>
    </div>

    <div class="modal-wrapper-holder" v-else>
      <div class="frame-modal-header">
        <div class=" name h2">{{ $static('item.more-inf', 'Опис товару:') }}</div>
        <a href="javascript:void(0);" @click="closeReadMore" class="close-cart">
          <img src="/images/icons/close.svg" alt="">
        </a>
      </div>
      <div class="frame-modal-body" v-if="item">
        <div class="info-text" v-html="$dynamic(item, item.description, 'description')">
        </div>
      </div>
    </div>
  </div>

  <div class="frame-modal-wrapper-bg read-more-modal-wrapper-bg" :class="{ 'is-visible': readMoreOpen }"
    @click="closeReadMore"></div>

  <ServiceRequestModal :settings="settings" :item="item" v-if="item" />
</template>

<script>
import ItemOption from '@/components/ItemOption';
import ItemUniqueOption from '@/components/ItemUniqueOption';
import ServiceRequestModal from '@/components/ServiceRequestModal';
import { fixBodyPadding } from '@/utils/fixBodyPadding';
import { applySeoMeta } from '@/utils/seo';

export default {
  name: 'ServiceItem',
  components: { ItemUniqueOption, ItemOption, ServiceRequestModal },
  props: ['category', 'id'],
  data() {
    return {
      item: undefined,
      // isOpen: false,
      upsaleItems: [],
      group: [],
      selectedPillType: "description",
      order: {
        count: 1,
        additionSelect: [],
        additionUSelect: []
      },

      itemImageEleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },
      itemCatalogEleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },
      itemCatalog2EleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },
    }
  },

  async mounted() {
    await this.fetchSettings()
    await this.getItem();

    window.scrollTo(0, 0);
    window.$('.product-images a').fancybox();
  },

  methods: {
    async fetchSettings() {
      const resp = await fetch('/public/settings');
      const data = await resp.json();
      if (data) {
        this.$store.commit('setSettings', data);
      }
    },

    openReadMore(pillType) {
      this.selectedPillType = pillType;
      fixBodyPadding();
      this.$store.commit('setReadMoreOpen', true);
      window.$('body').addClass('no-scroll');
    },

    closeReadMore() {
      fixBodyPadding();
      this.$store.commit('setReadMoreOpen', false);
      window.$('body').removeClass('no-scroll');
    },

    fancyClick(e) {
      if (window.change) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    isHot(item) {
      return item.advanced && item.advanced.hot
    },

    selectOption({ item, status }) {
      if (!this.order.additionSelect) {
        this.order.additionSelect = []
      }
      if (status) {
        this.order.additionSelect.push(item)
      } else {
        let idx = this.order.additionSelect.findIndex(x => x.id == item.id);
        if (idx > -1) {
          this.order.additionSelect.splice(idx, 1)
        }
      }
    },

    selectuOption({ item, status }) {
      if (!this.order.additionUSelect) {
        this.order.additionUSelect = []
      }
      if (status) {
        this.order.additionUSelect.push(item)
      } else {
        let idx = this.order.additionUSelect.findIndex(x => x._id == item._id);
        if (idx > -1) {
          this.order.additionUSelect.splice(idx, 1)
        }
      }
    },

    getItemImage(item) {
      if (item.preview && item.preview.includes('https://')) {
        return item.preview
      }
      return item.preview ? `${window.location.protocol}//${window.location.host}${item.preview}` : ''
    },

    getDiscount(item) {
      return item.preview ? (1 - Math.max(item.price / item.price_old, 0)) * 100 | 0 : ''
    },

    categoryURL(item) {
      let category = this.categories.find(x => x.id == item.category);
      return category?.info?.url ? category.info.url : ''
    },

    getURLImage(image) {
      if (image && image.includes('https://')) {
        return image
      }
      return `${window.location.protocol}//${window.location.host}${image}`
    },

    async getItem() {
      this.group = [];
      try {
        const response = await fetch(`/public/item/${this.id}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.result) {
          this.item = data.result;
          this.$ViewItem(this.item);
          await this.getUpsaleItems();
        }

        if (data.group) {
          this.group = data.group;
        }

        if (data.error === 'not found') {
          this.$router.push({ name: 'NotFound' });
          return;
        }

        // Обновление мета-данных
        if (this.item && this.item.advanced) {
          applySeoMeta({
            title: this.item.advanced.meta_title || this.$dynamic(this.item, this.item.title, 'title'),
            description: this.item.advanced.meta_description || '',
            pageType: 'item',
            item: this.item,
            settings: this.$store.getters.getSettings
          });
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    },

    async getUpsaleItems() {
      if (this.upsale && this.upsale.length) {
        try {
          const response = await fetch('/public/item', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ list: this.upsale.map(i => i.id) }),
          });

          // Проверка на успешный ответ
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();
          if (data.result) {
            this.upsaleItems = data.result;
          } else {
            console.error('No result in response data:', data);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      } else {
        console.warn('Upsale array is empty or undefined');
      }
    },

    isTouchDevice() {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    },

    mouseDownHandler(e, ref) {
      // Определяем элемент для нужного списка
      let scrollElement;
      let data;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }
      data.isMouseDown = true; // Устанавливаем флаг для активного списка
      data.sourceTargetClick = e.target;
      data.sourceTargetClickTime = new Date().getTime();
      data.pos = {
        left: scrollElement.scrollLeft,
        top: scrollElement.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      data.initialX = e.clientX;

      if (!this.isTouchDevice()) {
        scrollElement.style.userSelect = 'none';

        // Привязываем контекст для функций-обработчиков
        document.addEventListener('mousemove', (event) => this.mouseMoveHandler(ref, event));
        document.addEventListener('mouseup', (event) => this.mouseUpHandler(ref, event));
      }
    },

    mouseMoveHandler(ref, e) {
      let data;
      let scrollElement;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }

      if (!data.isMouseDown) return; // Проверяем состояние для конкретного списка

      const dx = e.clientX - data.pos.x;
      const dy = e.clientY - data.pos.y;

      scrollElement.scrollTop = data.pos.top - dy;
      scrollElement.scrollLeft = data.pos.left - dx;
    },

    mouseUpHandler(ref, e) {
      let data;
      let scrollElement;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }

      if (!data.isMouseDown) return;
      data.isMouseDown = false; // Сбрасываем флаг для конкретного списка

      const currentX = e.clientX;
      const xDifference = Math.abs(currentX - data.initialX);
      const now = new Date().getTime();

      if ((now - data.sourceTargetClickTime) < 500 && xDifference < 1) {
        let target = data.sourceTargetClick;
        while (target) {
          if (target.href) {
            if (scrollElement.classList.contains('image_list')) { break }
            this.$router.push(target.href.replaceAll(`${window.location.protocol}//${window.location.host}`, ""));
            break;
          }
          target = target.parentElement;
        }
      } else {
        if (!scrollElement.hasAttribute('data-fancybox')) {
          document.addEventListener('click', this.preventClick, true);
        }
      }
      document.removeEventListener('mousemove', (event) => this.mouseMoveHandler(ref, event));
      document.removeEventListener('mouseup', (event) => this.mouseUpHandler(ref, event));
    },
    preventClick(e) {
      e.stopImmediatePropagation();  // Останавливаем любое событие клика
      e.preventDefault();  // Отменяем стандартное действие
      document.removeEventListener('click', this.preventClick, true);  // Удаляем этот обработчик после срабатывания
    },

    truncateText(text, maxLength = 500) {
      if (text) {
        return text.length <= maxLength ? text : text.slice(0, maxLength) + "...";
      }
      return "";
    },

    openRequestModal() {
      fixBodyPadding();

      window.$('.service-request-modal-wrapper-bg').addClass('is-visible');
      window.$('body').addClass('no-scroll');

    }
  },

  computed: {
    menu_type() {
      return this.$store.getters.getSettings ? this.$store.getters.getSettings.menu_type : undefined
    },
    videos() {
      return this.item?.advanced?.videos?.length ? this.item.advanced.videos : undefined
    },
    consultant() {
      return this.settings && this.settings.consultant ? this.settings.consultant : false
    },
    categories() {
      return this.$store.getters.getCategories
    },
    settings() {
      return this.$store.getters.getSettings
    },
    options() {
      return this.item && this.item.advanced && this.item.advanced.options ? this.item.advanced.options : []
    },
    uOptions() {
      return this.item && this.item.advanced && this.item.advanced.uOption ? this.item.advanced.uOption : []
    },
    optionSettings() {
      return this.$store.getters.getOptionSettings ? this.$store.getters.getOptionSettings : []
    },
    itemPrice() {
      return this.item.price
    },
    addPrice() {
      return this.addition_price + this.addition_Uprice
    },
    price() {
      return (this.item.price * this.order.count) + this.addition_price + this.addition_Uprice
    },
    price_old() {
      return this.price + ((this.item.price_old - this.item.price) * this.order.count)
    },
    upsale() {
      return this.item && this.item.advanced && this.item.advanced.upsale ? this.item.advanced.upsale : []
    },
    addition_Uprice() {
      return this.order.additionUSelect.reduce((c, value) => value && value.price ? c + parseFloat(value.price) : c, 0)
    },
    addition_price() {
      return this.order.additionSelect.reduce((c, value) => value && value.price ? c + parseFloat(value.price) : c, 0)
    },
    basked() {
      return this.$store.state.busked
    },
    ingredient() {
      return this.item?.advanced?.options?.ingredient ? this.item?.advanced?.options?.ingredient.map(id => (
        this.ingridients?.list?.find(x => x.id === id)
      )).filter(i => !!i).sort((a, b) => a.order - b.order) : []
    },
    ingridients() {
      return this.$store.getters.getOptions?.ingredient ? this.$store.getters.getOptions.ingredient : {}
    },
    isHotItem() {
      return this.item && this.item.advanced && this.item.advanced.hot
    },
    isStock() {
      return this.item && this.item.stock
    },
    isCatalogMod() {
      return this.$store.getters.getSettings?.catalog_mod
    },
    readMoreOpen() {
      return this.$store.getters.getReadMoreOpen || false
    },
    isHtmlString(input) {
      const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
      return htmlTagRegex.test(input);
    },

    shortItemDescription() {
      const fullDescription = this.$dynamic(this.item, this.item.description, 'description');

      const maxTextLength = 700;

      //Если приходить строка в виде ткста без тегов
      function isHtmlString(input) {
        const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlTagRegex.test(input);
      }

      if (!isHtmlString(fullDescription)) {
        return fullDescription.length > maxTextLength ?
          { html: "<p>" + fullDescription.slice(0, maxTextLength) + "..." + "<p>", isReadMore: true } :
          { html: "<p>" + fullDescription + "<p>", isReadMore: false };
      }
      //---------------------------------------------

      let resultHTML = "";
      let textLength = 0;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = fullDescription;

      let hasSplitTag = false;
      for (let child of tempDiv.children) {
        if (child.tagName.toLowerCase() === "split") {
          hasSplitTag = true;
          break;
        }
      }

      if (hasSplitTag) {
        for (let child of tempDiv.children) {
          if (child.tagName.toLowerCase() === "split") break;
          resultHTML += child.outerHTML;
        }
        return { html: resultHTML, isReadMore: true };
      }

      let firstChild = true;

      for (let child of tempDiv.children) {
        if (firstChild) {
          resultHTML += child.outerHTML;
          textLength += child.innerText?.length || 0;
          firstChild = false;

          if (textLength > maxTextLength) {
            return { html: resultHTML, isReadMore: true };
          }
          continue;
        }

        if (!child.innerText) {
          resultHTML += child.outerHTML;
          continue;
        }

        if (textLength + child.innerText.length <= maxTextLength) {
          resultHTML += child.outerHTML;
          textLength += child.innerText.length;
        } else {
          resultHTML += child.outerHTML;
          return { html: resultHTML, isReadMore: true };
        }
      }

      return { html: resultHTML, isReadMore: false };
    },
    shortItemCharacteristics() {
      const fullCharacteristics = this.$dynamic(this.item, this.item.advanced.text1, 'text1');

      const maxTextLength = 700;

      //Если приходить строка в виде ткста без тегов
      function isHtmlString(input) {
        const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlTagRegex.test(input);
      }

      if (!isHtmlString(fullCharacteristics)) {
        return fullCharacteristics.length > maxTextLength ?
          { html: "<p>" + fullCharacteristics.slice(0, maxTextLength) + "..." + "<p>", isReadMore: true } :
          { html: "<p>" + fullCharacteristics + "<p>", isReadMore: false };
      }
      //---------------------------------------------

      let resultHTML = "";
      let textLength = 0;


      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = fullCharacteristics;

      let hasSplitTag = false;
      for (let child of tempDiv.children) {
        if (child.tagName.toLowerCase() === "split") {
          hasSplitTag = true;
          break;
        }
      }

      if (hasSplitTag) {
        for (let child of tempDiv.children) {
          if (child.tagName.toLowerCase() === "split") break;
          resultHTML += child.outerHTML;
        }
        return { html: resultHTML, isReadMore: true };
      }

      let firstChild = true;

      for (let child of tempDiv.children) {
        if (firstChild) {
          resultHTML += child.outerHTML;
          textLength += child.innerText?.length || 0;
          firstChild = false;

          if (textLength > maxTextLength) {
            return { html: resultHTML, isReadMore: true };
          }
          continue;
        }

        if (!child.innerText) {
          resultHTML += child.outerHTML;
          continue;
        }

        if (textLength + child.innerText.length <= maxTextLength) {
          resultHTML += child.outerHTML;
          textLength += child.innerText.length;
        } else {
          resultHTML += child.outerHTML;
          return { html: resultHTML, isReadMore: true };
        }
      }

      return { html: resultHTML, isReadMore: false };
    },
  },

  watch: {
    async id() {
      await this.getItem();
      this.order = {
        count: 1,
        additionSelect: [],
        additionUSelect: []
      };
      // window.$(`.category-panel-holder a.active`).removeClass('active');
      // window.$(`a[href="/catalog/${this.category}"]`).addClass('active');
      window.scrollTo(0, 0);
      window.$('.product-images a').fancybox();
      // window.$('.frame-modal-wrapper-bg').on('click', function () {
      //   window.$(this).removeClass('is-visible');
      //   window.$('body').removeClass('no-scroll');

      //   window.$('.frame-modal-list .first-level-item .level-sub').removeClass('open-level');
      //   window.$('#sort_filter,#sorting,#category_panel,#quick_cart').removeClass('opened');
      //   return false;
      // });
    }
  }
}
</script>

<style scoped>
.label-pic {
  display: inline-block;
  height: 11px;
  margin-right: 3px;
  vertical-align: middle;
  position: relative;
  top: -1px;
  width: 11px;
  margin-top: 0;
}

.videoBox {
  text-align: center;
  position: relative;
  padding-left: 75%;
}

.videoBox video {
  max-width: 100%;
  max-height: 100%;
  z-index: 11;
  width: 100%;
  position: absolute;
  top: 0;
  right: 50%;
  transform: translate(50%, 0);
}

.panel-body .text {
  overflow: hidden;
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
}

.product-top-hidden {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

.option-item-body input[type="radio"] {

  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;

  white-space: nowrap;
  clip-path: inset(100%);
  clip: rect(0 0 0 0);
  overflow: hidden;

}
</style>